import { Globe, Sparkles, Activity, ShieldCheck } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const techCards = [
  {
    Icon: Globe,
    title: 'Digital Bond Platforms',
    desc: 'Streamlined digital infrastructure for bond origination, documentation, and settlement across multiple jurisdictions.',
  },
  {
    Icon: Sparkles,
    title: 'AI-Powered Analytics',
    desc: 'Advanced algorithms for pricing optimization, investor matching, and market timing to maximize issuance outcomes.',
  },
  {
    Icon: Activity,
    title: 'Real-Time Market Intelligence',
    desc: 'Continuous monitoring of credit spreads, yield curves, and market sentiment to inform structuring decisions.',
  },
  {
    Icon: ShieldCheck,
    title: 'Secure Client Portal',
    desc: 'Encrypted, institutional-grade platform for document sharing, transaction tracking, and investor communications.',
  },
];

export default function Technology() {
  return (
    <section id="technology" className="py-20 sm:py-28" style={{ backgroundColor: '#0a1628' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <p className="text-sm font-inter font-semibold uppercase tracking-wider mb-3" style={{ color: '#c9a84c' }}>
            Technology & Innovation
          </p>
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl text-white mb-12">
            New Technologies. Reliable Outcomes.
          </h2>
        </ScrollReveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {techCards.map(({ Icon, title, desc }, i) => (
            <ScrollReveal key={title} delay={i * 100}>
              <div
                className="p-6 rounded-xl h-full"
                style={{
                  backgroundColor: '#0f2240',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                  transition: 'transform 300ms ease, border-color 300ms ease, box-shadow 300ms ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#c9a84c';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(201,168,76,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                data-testid={`tech-card-${i}`}
              >
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center mb-5"
                  style={{ backgroundColor: 'rgba(201,168,76,0.1)' }}
                >
                  <Icon className="w-6 h-6" strokeWidth={1.5} style={{ color: '#c9a84c' }} />
                </div>
                <h3 className="font-inter font-semibold text-white text-base mb-2">{title}</h3>
                <p className="font-inter text-sm leading-relaxed" style={{ color: '#9ca3af' }}>{desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
